module.exports = __webpack_public_path__ + "static/media/tagAdd.8016b007.svg";